// #region imports
import MuiContainer from './MuiContainer';
import MuiButton from './MuiButton';
import MuiDialog from './MuiDialog';
import MuiDialogTitle from './MuiDialogTitle';
import MuiDialogActions from './MuiDialogActions';
import MuiDialogContent from './MuiDialogContent';
import MuiTypography from './MuiTypography';
// #endregion

const components = {
  MuiButton,
  MuiContainer,
  MuiDialog,
  MuiDialogTitle,
  MuiDialogActions,
  MuiDialogContent,
  MuiTypography
};

export default components;
